var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellenOben(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1440 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.331 136.5C353.78 97.3 227.992 97.1667 184.167 102L26 120.5L138 211.5H1798.5V77C1650.97 96.5 1557.13 174 1361.92 136.5C1157.86 97.2986 1123.06 56 943.41 111.5C823.979 148.397 658.882 175.7 506.331 136.5Z",
    fill: "#6EADD4",
    fillOpacity: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 136.5C0 97.3 -125.333 97.1667 -169 102L-215 111.5V211.5H1439.5V77C1292.5 96.5 1199 174 1004.5 136.5C801.176 97.2986 766.5 56 587.5 111.5C468.5 148.397 304 175.7 152 136.5Z",
    fill: "#DC7545",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 136C164 96.8 38.6667 96.6667 -5 101.5L-51 165V211H1603.5V76.5C1456.5 96 1363 173.5 1168.5 136C965.176 96.7986 930.5 55.5 751.5 111C632.5 147.897 468 175.2 316 136Z",
    fill: "#FFFCF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 171,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellenOben);
export default __webpack_public_path__ + "static/media/wellen_oben.d6a1e272a78577e97ffc9cf5d1f70774.svg";
export { ForwardRef as ReactComponent };